(() => {

    // Block Name
    const blockName = 'content-menu';

    // Variables
    let method = 'front';
    if ( document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin') ) {
        method = 'wp-admin';
    }
    // -- end

    // Custom methods

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined ) block = block[0].querySelector(`.block-${blockName}`);
        if ( block === false || block === null ) return;

        // Block Code Here
        function stickyMenu() {
            let mainMenuHeight = jQuery('.page-header').outerHeight();
            let stickyHeight = jQuery('.block-content-menu .content-menu-wrapper').outerHeight();
            let stickyposition = jQuery('.block-content-menu').offset().top;
            if (jQuery(window).scrollTop() >= (stickyposition - mainMenuHeight)) {
                jQuery('.block-content-menu').height(stickyHeight);
                jQuery('.block-content-menu .content-menu-wrapper').addClass('fixed-header').css('top', mainMenuHeight);
            }
            else {
                jQuery('.block-content-menu .content-menu-wrapper').removeClass('fixed-header');
            }
        }

        jQuery( ".block-content-menu a" ).each(function() {
          let pretty = jQuery(this).data('pretty');
          let prettyID = jQuery('main section[data-pretty="'+pretty+'"]').attr('id');
          jQuery('main section[data-pretty="'+pretty+'"]').first().attr('data-pretty', '');
          if(prettyID !== undefined) {
              jQuery(this).attr('href', '#'+prettyID);
          }
        });

        stickyMenu();

        jQuery(window).scroll(function(){
            stickyMenu();
        });
        jQuery(window).on('resize', function () {
        	setTimeout(function () {
                stickyMenu();
        	}, 100);
        });

    };

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if ( blocks.length > 0 ) {
            blocks.forEach( (block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }

    });

})();
